import { render } from "./BuildingDimension.vue?vue&type=template&id=3f927daa&scoped=true"
import script from "./BuildingDimension.vue?vue&type=script&lang=js"
export * from "./BuildingDimension.vue?vue&type=script&lang=js"

import "./BuildingDimension.vue?vue&type=style&index=0&id=3f927daa&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f927daa"]])

export default __exports__